enum AccountStatus {
    NORMAL = 'NORMAL',
    CANCELED = 'CANCELED',
    BLOCKED = 'BLOCKED',
}
export default AccountStatus;
